<template>
	<div class="">
		<b-row class="mb-2 d-sm-none d-md-flex">
			<b-col class="pt-1" cols="10">
				<span class="function-title">Work Order Process</span>
			</b-col>
			<b-col cols="2">
				<span class="float-right">
					<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
						:show="isCreateBusy"
						opacity="0.6"
						spinner-small
						spinner-variant="default"
						class="d-inline float-right mt-1">
						<b-button class="btn-create btn-fill-success" @click="createData" size="sm"><b-icon-plus-square class="mr-1" />Create Request</b-button>
					</b-overlay>
				</span>
			</b-col>
		</b-row>
		<div class="inbox-approval">
			<div>
				<div class="inbox-list-header">
					<div class="inbox-action-button">
						<b-row class="ml-2 mr-2">
							<b-col cols="12" md="2" class="pr-0 pl-0 inbox-header-left" v-if="isHideCheckAllData">
								<b-row class="mr-md-0 ml-md-0">
									<b-col cols="10" md="12" class="pr-0 pr-md-0 pl-md-0 combo-my-inbox">
										<app-input-combobox :options="inboxTypes" optionsLabel="label" optionsKey="value" label-cols-sm="4" label-cols-lg="3" :model.sync="inboxType" class="input-inbox-type" size="sm" :nolabel="true" :selected="inboxTypeSelected" id="input-inbox-type" @change="getInboxData" />
									</b-col>
									<b-col cols="2" class="d-md-none d-sm-block">
										<b-button class="btn-action pt-2" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search></b-button>
									</b-col>
								</b-row>
							</b-col>
							<b-col cols="12" md="10" class="inbox-header-right pr-0 d-sm-flex d-md-block" v-if="isShowCheckAllData">
								<b-button class="float-left btn-action pt-055 d-sm-none d-md-inline" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> Advance Filter</b-button>
								<app-button-approval class="float-left pt-04" :disabled="checkAllData.length > 0 ? false : true" approvalType="Approve" @approvalMethod="approveInbox" :remarks.sync="remarks" :isBusy="isApprovalBusy" icon="check-circle" />
								<app-button-approval class="float-left pt-04" :disabled="checkAllData.length > 0 ? false : true" approvalType="Reject" @approvalMethod="rejectInbox" :remarks.sync="remarks" :isBusy="isApprovalBusy" icon="x-circle" />
								<app-button-approval class="float-left pt-04" :disabled="checkAllData.length > 0 ? false : true" approvalType="Revise" @approvalMethod="reviseInbox" :remarks.sync="remarks" :isBusy="isApprovalBusy" icon="filter-circle" />
								<b-button v-if="selectedModel != null" size="sm" class="btn-default ml-1 pt-044 float-right d-sm-none d-md-inline" @click="selectedModel = null;inboxDataBusy = false">
									<b-icon-x class="mr-1"></b-icon-x>Close
								</b-button>
								<span v-if="selectedModel != null" class="d-sm-none d-md-inline">
									<b-button v-if="selectedModel.statusId == 'APPROVED' || selectedModel.statusId == 'REJECTED' || selectedModel.statusId == 'CANCELED' || selectedModel.statusId == 'WAITING FOR APPROVAL' || selectedModel.statusId == 'REQUEST FOR REVISION'" class="btn-default float-right mb-2 mr-0" @click="showApprovalFlow" v-b-tooltip.hover title="Approval History"><b-icon icon="clock-history" /></b-button>
									<b-overlay
										v-if="false"
										:show="isPdfBusy"
										opacity="0.6"
										spinner-small
										spinner-variant="default"
										class="d-inline float-right">
											<b-button 
												class="btn-default float-right mb-2 mr-0"
												@click="printSingleData"
												:disabled="isPdfBusy"
												v-b-tooltip.hover
												title="Print">
												<b-icon icon="printer" />
											</b-button>
									</b-overlay>
								</span>
							</b-col>
						</b-row>
					</div>
				</div>
				<div class="overflow-hidden">
					<b-row>
						<div class="inbox-list col-12 col-md-2 pr-0 inbox-list-container">
							<div v-if="isDataLoading">
								<div :id="'inbox-item-' + index" class="inbox-item pl-3 pr-3 pt-3 pb-3" v-for="index in 5" :key="index">
									<b-skeleton animation="wave" width="85%"></b-skeleton>
									<b-skeleton animation="wave" width="55%"></b-skeleton>
									<b-skeleton animation="wave" width="70%"></b-skeleton>
								</div>
							</div>
							<div v-else-if="workOrderProcesss != null && workOrderProcesss.length > 0">
								<div :id="'inbox-item-' + index" :class="'inbox-item  pl-4 pr-3 pt-0 pb-0' + (isItemInboxActive(item) ? ' inbox-active' : '')" v-for="(item, index) in workOrderProcesss" :key="index">
									<b-row>
										<b-col cols="2" class="border-right pt-1 pb-1 p-0 inbox-item-left">
											<div class="d-flex justify-content-center ml-2 h-50 border-bottom" @click="toggleIsChecked(Number(item.id))">
												<b-form-checkbox class="mt-1" v-if="(item.statusId == 'WAITING FOR APPROVAL' || item.statusId == 'REQUEST FOR REVISION') && inboxType == 'INBOX'" :id="'input-checkbox-' + (index + 1)" @change="toggleIsChecked(Number(item.id))" :checked="checkAllData.includes(Number(item.id))"></b-form-checkbox>
											</div>
											<div class="d-flex justify-content-center h-50 pt-3" @click="selectedModel = item">
												<b-avatar v-if="item.status != null" v-b-tooltip.hover :title="(item.status != null ? item.status.name : '-')" :class="'badge-status-' + (item.status != null ? item.status.initial.toLowerCase() : '-')" :text="item.status != null ? item.status.initial : '-'"></b-avatar>
											</div>
										</b-col>
										<b-col class="pl-2 pt-1 pb-1 inbox-item-right" @click="selectedModel = item">
											<div :class="selectedModel != null ? (selectedModel.id == item.id ? 'inbox-item-title active' : 'inbox-item-title active') : 'inbox-item-title active'">
												{{ item.workOrderProcessNumber }} <br>
												{{ formatDate(item.productionDate) }} <br>
												{{ item.lineCode != null ? item.lineCode.name : '' }}
											</div>
											<div class="inbox-item-content">
												<b-row>
													<b-col>
														
													</b-col>
												</b-row>
												<b-row>
													<b-col>
														
													</b-col>
												</b-row>
											</div>
										</b-col>
									</b-row>
								</div>
								<div class="container my-3">
									<div class="col-md-12 text-center" v-if="(workOrderProcesssPaging != null ? workOrderProcesssPaging.pageCount : 0) > currentPage">
										<b-button class="btn-default" @click="loadNextInboxPage" size="sm">Load more data</b-button>
									</div>
								</div>
							</div>
							<div v-else class="inbox-item pl-3 pr-3 pt-3 pb-3">
								<div class="" style="text-align: center">No conversations</div>
							</div>
						</div>
						<div :class="selectedModel == null ? 'inbox-content col-10 pl-0 pr-3 inbox-list-container bg-white d-sm-none d-md-block' : 'inbox-content col-10 pl-0 pr-3 inbox-list-container bg-grey d-sm-none d-md-block'">
							<div v-if="selectedModel == null">
								<app-no-data-image width="100%" />
							</div>
							<div v-else-if="selectedModel.statusId != null && selectedModel.statusId != '' && selectedModel.statusId != undefined">
								<page-inbox-base :label="title" :isShow="selectedModel.statusId != null && selectedModel.statusId != '' && selectedModel.statusId != undefined" @resetModal="selectedModel = null;inboxDataBusy = false">
									<b-card class="mt-0 mb-0 ml-auto mr-auto card-detail" body-class="p-0">
										<div v-if="selectedModel.statusId == 'WAITING FOR APPROVAL' && inboxType == 'INBOX'">
											<InputInboxApproval :inboxType="inboxType" @approvalFlow="showApprovalFlow" @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
										<div v-else-if="selectedModel.statusId == 'REQUEST FOR REVISION'">
											<InputInboxNeedRevision :inboxType="inboxType" @approvalFlow="showApprovalFlow" @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
										<div v-else-if="selectedModel.statusId == 'DRAFT'">
											<InputInboxDraft @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
										<div v-else>
											<InputInboxSubmission :inboxType="inboxType" @approvalFlow="showApprovalFlow" @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
									</b-card>
								</page-inbox-base>
								<div class="inbox-list-footer d-md-block d-sm-none" v-if="showInboxFooter">
									<PortalTarget class="float-right d-flex mt-04 mr-3" name="app-inbox-button" />
								</div>
							</div>
							<div v-else>
								<app-no-data-image width="100%" />
							</div>
						</div>
					</b-row>
				</div>
				<Portal to="app-navbar-bottom">
					<span class="float-right">
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
								:show="isCreateBusy"
								opacity="0.6"
								spinner-small
								spinner-variant="default"
								class="d-inline float-right mt-1">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm"><b-icon-plus-square class="mr-1" />Create Request</b-button>
						</b-overlay>
					</span>
				</Portal>
			</div>
		</div>
		<RouterView />
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow" 
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success" 
			:cancel-title="'Clear'" 
			@ok="getInboxData"
			@hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-work-order-process-number" label-cols-sm="4" label-cols-lg="3" label="Work Order Process Number" label-for="filter-work-order-process-number" size="sm" :model.sync="filter.workOrderProcessNumber" />
					<app-input-datepicker-range  id="fieldset-production-date" label-cols-sm="4" label-cols-lg="3" label="Production Date" size="sm" :modelFrom.sync="filter.productionDateFrom" :modelTo.sync="filter.productionDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line Code" id="filter-" size="sm" :model.sync="filter.lineCodeId" @input="getLines" @focus="getLines" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="processTypes" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Process Type" id="filter-" size="sm" :model.sync="filter.processTypeId" @input="getProcessTypes" @focus="getProcessTypes" />
					<!-- <app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm" :model.sync="filter.documentStatusId" @input="getDocumentStatuss" @focus="getDocumentStatuss" /> -->

					<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getInboxData"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
				Clear
			</b-button>
			<b-overlay
				:show="isDataLoading"
				rounded
				opacity="0.6"
				spinner-small
				spinner-variant="primary"
				class="float-right "
				>
				<b-button size="sm" class="float-right btn-default" @click="ok()">
					Search
				</b-button>
			</b-overlay>
			</template>
		</b-modal>
		<PopupApprovalHistory label="Approval History" :openPopup="isShowApprovalHistory" @resetModalMethod="resetModal" :approvalInstanceId="approvalHistoryId" />
		<PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
	</div>
</template>
<script>
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import ProcessType from '@/models/ProcessType/ProcessType';
import ProcessTypeFilter from '@/filters/ProcessType/ProcessTypeFilter';

import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessList from '@/models/WorkOrderProcess/WorkOrderProcessList';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTimepicker from '@/components/AppInputTimepicker';
import AppInputTimepickerRange from '@/components/AppInputTimepickerRange';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import AppButtonApproval from '@/components/AppButtonApproval';
import AppInputCombobox from '@/components/AppInputCombobox';
import InputInboxApproval from './InputInboxApproval';
import InputInboxNeedRevision from './InputInboxNeedRevision';
import InputInboxSubmission from './InputInboxSubmission';
import InputInboxDraft from './InputInboxDraft';
import PopupApprovalHistory from '@/components/PopupApprovalHistory.vue';
import PageInboxBase from '@/components/PageInboxBase.vue';

export default {
	components : {
		WorkOrderProcess,
		WorkOrderProcessList,
		WorkOrderProcessFilter,
		AppLabel,
		AppInputTextbox,
		AppInputTextarea,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTimepicker,
		AppInputTimepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputComboboxAutocomplete,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
		Upload,
		AppButtonApproval,
		AppInputCombobox,
		InputInboxApproval,
		InputInboxNeedRevision,
		InputInboxSubmission,
		InputInboxDraft,
		PopupApprovalHistory,
		PageInboxBase,
	},
	data() {
		return {
			title: 'Work Order Process',
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			inboxTypes: [
				{ value : 'INBOX', label : 'My Inbox', selected:true },
				{ value : 'SUBMISSION', label : 'My Submission' },
				{ value : 'FINISHEDSUBMISSION', label : 'My Finished Submission'},
				{ value : 'DRAFT', label : 'Draft' },
				{ value : "REQUESTEDDATA", label: "Requested Data" },
			],
			inboxType: 'INBOX',
			inboxTypeSelected: 'My Inbox',
			perPage: 10,
			currentPage: 1,
			totalData:0,
			busy:false,
			isDataLoading: false,
			isMultiplePrintBusy: false,
			isShowApprovalHistory: false,
			approvalHistoryId: 0,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			workOrderProcesss: [],
			workOrderProcesssPaging: {},
			isFilterShow: false,
			isDeleteBusy: false,
			selectedModel: null,
			inboxDataBusy: false,
			isApprovalBusy: false,
			remarks: "",
			popoverShow: false,
			approvalType: "",
			windowWidth: 0,
			isShowPopupPDF: false,
			isPdfBusy: false,
			pdfUrl: '',
		workOrderProcessDetails: [],
		parts: [],
		billOfProcesss: [],
		machines: [],
		documentStatuss: [],
		lines: [],
		processTypes: [],

		}
	},	
	methods : {
		formatDate(inputDate) {
			if(!inputDate) return '';
			let date = new Date(inputDate);
			let formattedDate = date.toISOString().split('T')[0];
			return formattedDate;
		},
		getInboxData() {
			this.currentPage = 1;
			this.workOrderProcesss = [];
			if (this.inboxType == "INBOX") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = "WAITING FOR APPROVAL,REQUEST FOR REVISION";
				return this.getWorkOrderProcessInboxes();
			}
			else if (this.inboxType == "SUBMISSION") {
				this.filter["statusId"] = null;
				this.filter["notStatusId"] = "APPROVED,REJECTED,CANCELED,DRAFT";
				this.filter["statusNotEmpty"] = true;
				this.getWorkOrderProcessSubmissions();
			} 
			else if (this.inboxType == "FINISHEDSUBMISSION") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = "APPROVED,REJECTED,CANCELED";
				this.getWorkOrderProcessSubmissions();
			}
			else if (this.inboxType == "DRAFT") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = "DRAFT";
				this.getWorkOrderProcessDraft();
			}
			else if (this.inboxType == "REQUESTEDDATA") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = null;
				this.filter["statusNotEmpty"] = true;
				this.getWorkOrderProcessRequestedData();
			}
		},
		loadNextInboxPage() {
			this.currentPage++;
			if (this.inboxType == "INBOX") {
				this.getWorkOrderProcessInboxes();
			}
			else if (this.inboxType == "SUBMISSION") {
				this.getWorkOrderProcessSubmissions();
			} 
			else if (this.inboxType == "FINISHEDSUBMISSION") {
				this.getWorkOrderProcessSubmissions();
			}
			else if (this.inboxType == "DRAFT") {
				this.getWorkOrderProcessDraft();
			}
			else if (this.inboxType == "REQUESTEDDATA") {
				this.getWorkOrderProcessRequestedData();
			}
		},
		getWorkOrderProcessInboxes : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			return WorkOrderProcess.getMyApprovalList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					// this.workOrderProcesss = result.data
					result.data.forEach(item => {
						this.workOrderProcesss.push(item);
					});
					this.workOrderProcesssPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderProcessRequestedData : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			WorkOrderProcess.getRequestedDataList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
				result.data.forEach(item => {
					this.workOrderProcesss.push(item);
				});
				this.workOrderProcesssPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderProcessSubmissions : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			WorkOrderProcess.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					// this.workOrderProcesss = result.data
					result.data.forEach(item => {
						this.workOrderProcesss.push(item);
					});
					this.workOrderProcesssPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderProcessDraft : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			WorkOrderProcess.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					// this.workOrderProcesss = result.data
					result.data.forEach(item => {
						this.workOrderProcesss.push(item);
					});
					this.workOrderProcesssPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderProcesssWithoutLoading : async function() {
			this.selectedModel = null;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			if (this.inboxType == "INBOX") {
				this.filter["statusId"] = "WAITING FOR APPROVAL,REQUEST FOR REVISION";
				WorkOrderProcess.getMyApprovalList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderProcesss = result.data
						this.workOrderProcesssPaging = result
					}
				})
				.catch(error => {});
			} else if (this.inboxType == "SUBMISSION") {
				this.filter["statusId"] = "";
				WorkOrderProcess.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderProcesss = result.data
						this.workOrderProcesssPaging = result
					}
				})
				.catch(error => {});
			} else if (this.inboxType == "DRAFT") {
				this.filter["statusId"] = "DRAFT";
				WorkOrderProcess.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderProcesss = result.data
						this.workOrderProcesssPaging = result
					}
				})
				.catch(error => {});
			}
		},
		getWorkOrderProcessDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderProcessDetail);
			if (this.modelId == null) return;
			filter.workOrderProcessId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByWorkOrderProcessDetail != null) {
				this.sortingByWorkOrderProcessDetail[this.sortByWorkOrderProcessDetail] = this.sortDescWorkOrderProcessDetail;
			}
			let currentPage = (this.currentWorkOrderProcessDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderProcessDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderProcessDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderProcessDetailPageSize = 0;
			// disable paging end
			WorkOrderProcessDetail.getList(this, filter, this.sortingByWorkOrderProcessDetail, currentPage , this.workOrderProcessDetailPageSize).then(result => {
				this.currentWorkOrderProcessDetailPage = currentPage + 1;
				this.workOrderProcessDetails = result.data;
				this.totalWorkOrderProcessDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			this.isWorkOrderProcessComboLoading = true;
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
				this.isWorkOrderProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getBillOfProcesss : async function(input) {
			let filter = new BillOfProcessFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isBillOfProcessComboLoading = true;
			BillOfProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcesss = result.data
				}
				this.isBillOfProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isMachineComboLoading = true;
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
				this.isMachineComboLoading = false;
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLineCode(item) {
			if(item == undefined || item == null) {
				this.model.lineCodeId = null;
				this.model.lineCode = null;
			} else {
				this.model.lineCodeId = item.id;
				this.model.lineCode = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getProcessTypes : async function(input) {
			let filter = new ProcessTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProcessType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.processTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessType(item) {
			if(item == undefined || item == null) {
				this.model.processTypeId = null;
				this.model.processType = null;
			} else {
				this.model.processTypeId = item.id;
				this.model.processType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onProcessTypeChange : async function() {
			this.model.lineCodeId = null;
			this.model.lineCode = null;

let item = this.model.processTypeId;
let processTypeObj = this.processTypes.filter(function(processType){ return processType.id == item; });
this.model.processType = processTypeObj.length > 0 ? processTypeObj[0] : null;
			this.getLineCode();
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},

		resetFilter() {
			this.filter = new WorkOrderProcessFilter();
			this.getInboxData();
			this.isFilterShow = false;
		},
		resetModal() {
			this.isFilterShow = false;
		},
		toggleIsChecked(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		createData() {
			this.isCreateBusy = true;
			WorkOrderProcess.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workorderprocesscreateinboxrequest', params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			WorkOrderProcess.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workorderprocessdetailapproval', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		toggleInboxDataBusy() {
			if (this.inboxDataBusy)
				this.inboxDataBusy = false;
			else
				this.inboxDataBusy = true;
		},
		successAction() {
			this.selectedModel = null;
			this.inboxDataBusy = false
			this.getInboxData();
		},
		approveInbox() {
			let data = this.$store.state.dataIds;
			this.popoverShow = false;
			if (data.length > 0) {
				this.isApprovalBusy = true;
				WorkOrderProcess.approveMultipleData(this, this.remarks).then(result => {
					this.isApprovalBusy = false;
					this.remarks = "";
					this.getInboxData();
				}).catch(error => {
					this.isApprovalBusy = false;	
				});
			}
		},
		rejectInbox() {
			let data = this.$store.state.dataIds;
			this.popoverShow = false;
			if (data.length > 0) {
				this.isApprovalBusy = true;
				WorkOrderProcess.rejectMultipleData(this, this.remarks).then(result => {
					this.isApprovalBusy = false;
					this.remarks = "";
					this.getInboxData();
				}).catch(error => {
					this.isApprovalBusy = false;	
				});
			}
		},
		reviseInbox() {
			let data = this.$store.state.dataIds;
			this.popoverShow = false;
			if (data.length > 0) {
				this.isApprovalBusy = true;
				WorkOrderProcess.reviseMultipleData(this, this.remarks).then(result => {
					this.isApprovalBusy = false;
					this.remarks = "";
					this.getInboxData();
				}).catch(error => {
					this.isApprovalBusy = false;	
				});
			}
		},
		resetModal() {
			this.isShowApprovalHistory = false;
			this.isShowPopupPDF = false;
		},
		showApprovalFlow() {
			if(this.selectedModel != null && this.selectedModel != undefined) {
				this.approvalHistoryId =  this.selectedModel.approvalInstanceId;
				this.isShowApprovalHistory = true;
			}
		},
		printSingleData() {
			this.isPdfBusy = true;
			if(this.selectedModel != null && this.selectedModel != undefined) {
				WorkOrderProcess.singleDataPagePrint(this, this.selectedModel.id).then(result => {
					if (result) {
						this.showPopupPDF(result.download);
					}
					this.isPdfBusy = false;
				});
			} else {
				this.isPdfBusy = false;
			}
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new WorkOrderProcessFilter();
	},
	mounted(){
		let breadcrumb = [
			"Work Order Process"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.windowWidth = window.innerWidth;
		let submission = this.$route.query.submission;
		if (submission != null && submission != undefined && submission == '1') {
			this.inboxType = 'SUBMISSION';
			this.inboxTypeSelected = 'My Submission';
		}
		let inboxType = this.$route.query.type;
		if (inboxType != null && inboxType != undefined && inboxType != '') {
			this.inboxType = inboxType;
		}
		this.$nextTick(() => {
			this.getInboxData().then(result => {
				let documentId = this.$route.query.id
				let item = this.workOrderProcesss.filter(e=>e.id == documentId)
				if(item.length > 0) {
					this.selectedModel = item[0]
				}
			});
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
	/*
		sortBy: {
			handler: function() {
				this.getInboxData();
			}
		},
		sortDesc: {
			handler: function() {
				this.getInboxData();
			}
		},
		currentPage: {
			handler: function() {
				this.getInboxData();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getInboxData();
			}
		},
		*/
		selectAll(newValue) {
			if (newValue) {
				WorkOrderProcess.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (from.name == "workorderprocesscreateinboxrequest") {
					// this.getWorkOrderProcesssWithoutLoading();
					this.getInboxData();
				}
			}
		},
	},
	computed: {
		isItemInboxActive: function () {
			var vm = this;
			return function (item) {
				if (vm.selectedModel != null) {	
					if (vm.selectedModel.id == item.id) return true;
				} 
				if (vm.checkAllData.length > 0) {
					if (vm.checkAllData.includes(Number(item.id))) return true;
				}
				return false;
			};
		},
		isHideCheckAllData() {
			if (this.windowWidth > 576) return true;
			return this.checkAllData.length <= 0;
		},
		isShowCheckAllData() {
			if (this.windowWidth > 576) return true;
			return this.checkAllData.length > 0;
		},
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "work_order_process").first();
		},
		showInboxFooter() {
			if (this.selectedModel != null && this.selectedModel != undefined) {
				if ((this.selectedModel.statusId == 'WAITING FOR APPROVAL' && this.inboxType == "INBOX") || 
					this.selectedModel.statusId == 'DRAFT' || 
					(this.selectedModel.statusId == 'REQUEST FOR REVISION' && this.inboxType == "INBOX") ||
					this.selectedModel.statusId == 'APPROVED'
					)
					return true;
			}
			return false;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
